import React, { useEffect, useState } from 'react'
import styles from './index.module.scss'
import { Box, Grid } from '@mui/material'

type CircleCheckboxProps = {
  checked?: boolean
  onChange?: (checked: boolean) => void
}
const CircleCheckbox = ({ checked = false, onChange }: CircleCheckboxProps) => {
  const [isChecked, setIsChecked] = useState(false)

  const handleClick = () => {
    if (typeof onChange === 'function') {
      onChange(!isChecked)
    }
    setIsChecked((prevState) => !prevState)
  }
  useEffect(() => {
    setIsChecked(checked)
  }, [checked])
  return (
    <Grid alignItems='center' justifyContent='center' container onClick={handleClick}>
      <div className={styles.checkedWrapper}>{isChecked && <div className={styles.checked}></div>}</div>
    </Grid>
  )
}

export default CircleCheckbox
